import {
  schoolRecommendationCatalogApi,
  schoolRecommendationApi,
} from '../../_api';
import { initSearchModelState } from '../../_utils';
import academicYearService from '@/services/academicyear';

export const SearchMixin = {
  props: {
    academicYearId: { type: [Number, String], default: null },
    region: { type: Object, default: null },
    selectRegion: { type: Boolean, default: false },
    excludeRegion: { type: Boolean, default: false },
    municipality: { type: Object, default: null },
    selectMunicipality: { type: Boolean, default: true },
    excludeMunicipality: { type: Boolean, default: false },
    schoolsAdded: { type: Array, default: () => [] },
    tapRequestId: { type: [Number, String], required: true, default: null },
    /* SchoolRecommendationModel */
    item: { type: Object, default: null },
  },
  data: () => ({
    catalog: { regions: [], municipalities: [], schools: [] },
    filter: initSearchModelState(),
  }),
  computed: {
    catalogRegions() {
      if (this.excludeRegion) {
        return this.catalog.regions?.filter((x) => x.id !== this.region?.id);
      }
      return this.catalog.regions;
    },
    catalogMunicipalities() {
      if (this.excludeMunicipality) {
        return this.catalog.municipalities?.filter(
          (x) => x.id !== this.municipality?.id
        );
      }
      return this.catalog.municipalities;
    },
    catalogSchools() {
      if (!this.schoolsAdded.length) {
        return this.catalog.schools;
      }
      const schoolsAddedIds = this.schoolsAdded.map((x) => x.id);
      return this.catalog.schools?.filter(
        (x) => !schoolsAddedIds.includes(x.id)
      );
    },
  },
  methods: {
    async getRegions() {
      const data = await schoolRecommendationCatalogApi.getRegions({
        academicYearId: this.academicYearId,
      });
      this.catalog.regions = data;
    },
    async getMunicipalities({ regionId }) {
      const data = await schoolRecommendationCatalogApi.getMunicipalities({
        academicYearId: this.academicYearId,
        regionId,
      });
      this.catalog.municipalities = data;
    },
    async getSchools({ regionId, municipalityId }) {
      const data = await schoolRecommendationCatalogApi.getSchools({
        academicYearId: this.academicYearId,
        regionId,
        municipalityId,
      });
      this.catalog.schools = data;
    },
    async search() {
      const formValid = await this.$refs['form'].validate();
      if (!formValid) return;

      let academicYearId = this.academicYearId;
      if (this.academicYearId) {
        const {
          data: academicYear,
        } = await academicYearService.getAcademicYearById(this.academicYearId);
        const isFutureAcademicYear = academicYear?.isFutureYear ?? false;
        if (isFutureAcademicYear) {
          const {
            data: currentYear,
          } = await academicYearService.getCurrentAcademicYear();
          academicYearId =
            currentYear?.id ?? currentYear?.Id ?? this.academicYearId;
        }
      }

      const data = await schoolRecommendationApi.searchAlternatives({
        academicYearId,
        schoolId: this.filter.school?.id,
        requestId: this.tapRequestId,
      });
      this.$emit('search', { filter: this.filter, result: data });
    },
  },
  watch: {
    'filter.region': {
      async handler(value) {
        if (this.item) return;
        this.$emit('filterChanged', true);
        if (this.selectMunicipality) {
          this.catalog.municipalities = [];
          this.filter.municipality = null;
          this.catalog.schools = [];
          this.filter.school = null;
        }
        if (!value?.id || !this.selectMunicipality) return;
        await this.getMunicipalities({ regionId: value?.id });
      },
      deep: true,
      immediate: true,
    },
    'filter.municipality': {
      async handler(value) {
        if (this.item) return;
        this.$emit('filterChanged', true);
        this.catalog.schools = [];
        this.filter.school = null;
        if (!value?.id || !this.filter.region?.id) return;
        await this.getSchools({
          regionId: this.filter.region?.id,
          municipalityId: value?.id,
        });
      },
      deep: true,
      immediate: true,
    },
    'filter.school': {
      handler() {
        if (this.item) return;
        if (!this.filter.municipality?.id) return;
        this.$emit('filterChanged', true);
      },
      deep: true,
    },
  },
};
